/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu';
import { LinqService, QueryOptions } from 'linquest';
import {
  PerformanceFormDetailKeyResultStatusDto,
  PerformanceFormDetailKeyResultStatusTranslatedDto,
} from './models';

/**
 * PerformanceFormDetailKeyResultStatusApi - API class
 */
export class PerformanceFormDetailKeyResultStatusApi extends LinqService {

  /**
   * Creates a new PerformanceFormDetailKeyResultStatusApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param id 
   */
  getAsync(id?: 0 | 1 | 2 | 3 | 4 | 5, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailKeyResultStatus/GetAsync`;
    let query = this.createQuery<PerformanceFormDetailKeyResultStatusDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: 0 | 1 | 2 | 3 | 4 | 5, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailKeyResultStatus/GetTranslatedAsync`;
    let query = this.createQuery<PerformanceFormDetailKeyResultStatusTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailKeyResultStatus/List`;
    let query = this.createQuery<PerformanceFormDetailKeyResultStatusDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailKeyResultStatus/ListTranslated`;
    let query = this.createQuery<PerformanceFormDetailKeyResultStatusTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }
}
